<div class="metadata-div">

  <span class="input-field-label" [matTooltip]="label" matTooltipPosition="above">
    <b>{{label}}</b>
  </span>

<!--  <div *ngIf="visibility === 'MT_O'" class="only-read-metadata-data-div">-->
<!--    {{humanvalue}}-->
<!--  </div>-->
  <app-meta-data-onlyread *ngIf="visibility === 'MT_O'" [value]="humanvalue" [title]="label"></app-meta-data-onlyread>

  <mat-form-field *ngIf="visibility === 'MT_K' || visibility === 'MT_M'">
    <mat-select [formControl]="optionFormControl"
                [required]="visibility === 'MT_K'"
                (selectionChange)="onChangeValue($event.value)"
                placeholder="{{'NOT_SELECTED' | translate}}">
      <mat-option *ngFor="let option of options" [value]="option.valueIndex">
        {{option.valueView}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="optionFormControl.hasError('required')">
      {{'MANDATORY_FIELD' | translate}}
    </mat-error>
  </mat-form-field>

</div>
